import { CategoryType, GoogleRssTopic, Language, LanguageLevel } from '@shared/openapi/jaaluu-api';
import { language } from '.';
import { CATEGORIES_DE } from './categories/de';
import { CATEGORIES_EN } from './categories/en';
import { CATEGORIES_ES } from './categories/es';
import { CATEGORIES_FR } from './categories/fr';
import { CATEGORIES_IT } from './categories/it';
import { CATEGORIES_PL } from './categories/pl';
import { CATEGORIES_PT } from './categories/pt';
import { CATEGORIES_RU } from './categories/ru';
import { CATEGORIES_ZH } from './categories/zh';

const TRANS: {
  [key: string]: {
    general: {
      feeds: string;
      videos: string;
      kids: string;
      wikipedia: string;
      books: string;
      kids_lexicon: string;
      conversations: string;
      write: string;
      grammar: string;
      translate: string;
      vocabulary: string;
      jokes: string;
      live_conversations: string;
      transcription: string;
      video_object_detection: string;
    };
    feed_topics: {
      [key in GoogleRssTopic]: string;
    };
    chat: {
      chat: string;
      language_teacher: string;
    };
    category: {
      show_all_about: string;
      [CategoryType.PHRASES]: string;
      [CategoryType.SAYINGS]: string;
      [CategoryType.SIMPLE_TEXTS]: string;
      [CategoryType.CONVERSATIONS]: string;
      [CategoryType.WRITE]: string;
      course: string;
      categories: any;
    };
    custom: {
      own_text: string;
    };
    special_vocabulary: {
      special_vocabulary: string;
    };
    custom_vocabulary: {
      custom_vocabulary: string;
    };
    write: {
      subject: string;
      message: string;
      from: string;
      to: string;
      send: string;
    };
    course: {
      welcome: string;
      story: string;
      vocabularies: string;
      flipcards: string;
      exercises: string;
      sentences_only: string;
      gap_text: string;
      flipcard_loosers: string;
      exercises_loosers: string;
      grammar: string;
      phrases: string;
      phrases_repeat: string;
      sentence_matcher: string;
      def_matcher: string;
      train_questions: string;
    };
  };
} = {
  [Language.DE]: {
    general: {
      feeds: 'Nachrichten',
      videos: 'Videos',
      kids: 'Kinder',
      wikipedia: 'Wikipedia',
      books: 'Bücher',
      kids_lexicon: 'Lexikon für Kinder',
      conversations: 'Chat',
      write: 'Schreiben',
      grammar: 'Grammatik',
      translate: 'Übersetzen',
      vocabulary: 'Vokabeln',
      jokes: 'Witze',
      live_conversations: 'Sprechen',
      transcription: 'Transkription',
      video_object_detection: 'Objekterkennung'
    },
    feed_topics: {
      world: 'WELT',
      business: 'WIRTSCHAFT',
      technology: 'TECHNOLOGIE',
      entertainment: 'UNTERHALTUNG',
      science: 'WISSENSCHAFT',
      sports: 'SPORT',
      health: 'GESUNDHEIT',
      nation: 'NATION'
    },
    chat: {
      chat: 'Chat',
      language_teacher: 'Sprachlehrer'
    },
    category: {
      show_all_about: 'Alles anzeigen über',
      categories: CATEGORIES_DE,
      [CategoryType.PHRASES]: 'Phrasen',
      [CategoryType.SIMPLE_TEXTS]: 'Einfache Texte',
      [CategoryType.SAYINGS]: 'Redewendungen',
      [CategoryType.CONVERSATIONS]: 'Konversationen',
      [CategoryType.WRITE]: 'Schreiben',
      course: 'Kurs'
    },
    custom: {
      own_text: 'Eigener Text'
    },
    special_vocabulary: {
      special_vocabulary: 'Spezieller Wortschatz'
    },
    custom_vocabulary: {
      custom_vocabulary: 'Meine Vokabeln'
    },
    write: {
      subject: 'Betreff',
      message: 'Nachricht',
      from: 'Von',
      to: 'An',
      send: 'Senden'
    },
    course: {
      welcome: 'Willkommen zum Kurs. Fangen wir mit ein paar einfachen Wörtern und Sätzen an.',
      story: 'Kurzgeschichte',
      vocabularies: 'Vokabeln',
      flipcards: 'Wiederholung mit Karteikarten',
      exercises: 'Wortschatzübungen',
      sentences_only: 'Zusammenfassung der Sätze',
      gap_text: 'Lückentext-Übung',
      flipcard_loosers: 'Wiederholung schwieriger Wörter',
      exercises_loosers: 'Übungen schwieriger Wörtern',
      grammar: 'Grammatiklektion',
      phrases: 'Phrases',
      phrases_repeat: 'Phrasen wiederholen',
      sentence_matcher: 'Satzzuordnung',
      def_matcher: 'Definitionszuordnung',
      train_questions: 'Fragen üben'
    }
  },
  [Language.EN]: {
    general: {
      feeds: 'News',
      videos: 'Videos',
      kids: 'Kids',
      wikipedia: 'Wikipedia',
      books: 'Books',
      kids_lexicon: 'Kids lexicon',
      conversations: 'Chat',
      write: 'Write',
      grammar: 'Grammar',
      translate: 'Translate',
      vocabulary: 'Vocabulary',
      jokes: 'Jokes',
      live_conversations: 'Talk',
      transcription: 'Transcription',
      video_object_detection: 'Object Detection'
    },
    feed_topics: {
      world: 'WORLD',
      business: 'BUSINESS',
      technology: 'TECHNOLOGY',
      entertainment: 'ENTERTAINMENT',
      science: 'SCIENCE',
      sports: 'SPORTS',
      health: 'HEALTH',
      nation: 'NATION'
    },
    chat: {
      chat: 'Chat',
      language_teacher: 'Language Teacher'
    },
    category: {
      show_all_about: 'Show all about',
      [CategoryType.PHRASES]: 'Phrases',
      [CategoryType.SIMPLE_TEXTS]: 'Simple texts',
      [CategoryType.SAYINGS]: 'Sayings',
      [CategoryType.CONVERSATIONS]: 'Conversations',
      [CategoryType.WRITE]: 'Write',
      course: 'Course',
      categories: CATEGORIES_EN
    },
    custom: {
      own_text: 'Own text'
    },
    special_vocabulary: {
      special_vocabulary: 'Special vocabulary'
    },
    custom_vocabulary: {
      custom_vocabulary: 'My Vocabulary'
    },
    write: {
      subject: 'Subject',
      message: 'Message',
      from: 'From',
      to: 'To',
      send: 'Send'
    },
    course: {
      welcome: "Welcome to the course. Let's start with some simple words and sentences.",
      story: 'Short story',
      vocabularies: 'Vocabulary',
      flipcards: 'Flashcard review',
      exercises: 'Vocabulary exercises',
      sentences_only: 'Summary of sentences',
      gap_text: 'Fill-in-the-blank exercise',
      flipcard_loosers: 'Review of difficult words',
      exercises_loosers: 'Exercises for difficult words',
      grammar: 'Grammar lesson',
      phrases: 'Phrases',
      phrases_repeat: 'Phrases repeat',
      sentence_matcher: 'Sentence matching',
      def_matcher: 'Definition matching',
      train_questions: 'Practice questions'
    }
  },
  [Language.ES]: {
    general: {
      feeds: 'Noticias',
      videos: 'Videos',
      kids: 'Niños',
      wikipedia: 'Wikipedia',
      books: 'Libros',
      kids_lexicon: 'Lexicon para niños',
      conversations: 'Chat',
      write: 'Escribir',
      grammar: 'Gramática',
      translate: 'Traducir',
      vocabulary: 'Vocabulario',
      jokes: 'Chistes',
      live_conversations: 'Hablar',
      transcription: 'Transcripción',
      video_object_detection: 'Detección de Objetos'
    },
    feed_topics: {
      world: 'MUNDO',
      business: 'NEGOCIOS',
      technology: 'TECNOLOGÍA',
      entertainment: 'ENTRETENIMIENTO',
      science: 'CIENCIA',
      sports: 'DEPORTES',
      health: 'SALUD',
      nation: 'NACIÓN'
    },
    chat: {
      chat: 'Chat',
      language_teacher: 'Profesor de idiomas'
    },
    category: {
      show_all_about: 'Mostrar todo sobre',
      [CategoryType.PHRASES]: 'Frases',
      [CategoryType.SIMPLE_TEXTS]: 'Textos simples',
      [CategoryType.SAYINGS]: 'Dichos',
      [CategoryType.CONVERSATIONS]: 'Conversaciones',
      [CategoryType.WRITE]: 'Escribir',
      course: 'Curso',
      categories: CATEGORIES_ES
    },
    custom: {
      own_text: 'Texto propio'
    },
    special_vocabulary: {
      special_vocabulary: 'Vocabulario especial'
    },
    custom_vocabulary: {
      custom_vocabulary: 'Mi vocabulario'
    },
    write: {
      subject: 'Asunto',
      message: 'Mensaje',
      from: 'De',
      to: 'Para',
      send: 'Enviar'
    },
    course: {
      welcome: 'Bienvenido al curso. Comencemos con algunas palabras y oraciones simples.',
      story: 'Historia corta',
      vocabularies: 'Vocabulario',
      flipcards: 'Repaso con tarjetas',
      exercises: 'Ejercicios de vocabulario',
      sentences_only: 'Resumen de oraciones',
      gap_text: 'Ejercicio de llenar espacios',
      flipcard_loosers: 'Repaso de palabras difíciles',
      exercises_loosers: 'Ejercicios de palabras difíciles',
      grammar: 'Lección de gramática',
      phrases: 'Phrases',
      phrases_repeat: 'Repetición de frases',
      sentence_matcher: 'Ejercicio de emparejamiento de oraciones',
      def_matcher: 'Ejercicio de emparejamiento de definiciones',
      train_questions: 'Preguntas de práctica'
    }
  },
  [Language.FR]: {
    general: {
      feeds: 'Nouvelles',
      videos: 'Vidéos',
      kids: 'Enfants',
      wikipedia: 'Wikipedia',
      books: 'Livres',
      kids_lexicon: 'Lexique pour enfants',
      conversations: 'Chat',
      write: 'Écrire',
      grammar: 'Grammaire',
      translate: 'Traduire',
      vocabulary: 'Vocabulaire',
      jokes: 'Blagues',
      live_conversations: 'Parler',
      transcription: 'Transcription',
      video_object_detection: "Détection d'Objets"
    },
    feed_topics: {
      world: 'MONDE',
      business: 'AFFAIRES',
      technology: 'TECHNOLOGIE',
      entertainment: 'DIVERTISSEMENT',
      science: 'SCIENCE',
      sports: 'SPORTS',
      health: 'SANTÉ',
      nation: 'NATION'
    },
    chat: {
      chat: 'Chat',
      language_teacher: 'Professeur de langue'
    },
    category: {
      show_all_about: 'Tout afficher sur',
      [CategoryType.PHRASES]: 'Phrases',
      [CategoryType.SIMPLE_TEXTS]: 'Textes simples',
      [CategoryType.SAYINGS]: 'Proverbes',
      [CategoryType.CONVERSATIONS]: 'Conversation',
      [CategoryType.WRITE]: 'Écrire',
      course: 'Cours',
      categories: CATEGORIES_FR
    },
    custom: {
      own_text: 'Texte propre'
    },
    special_vocabulary: {
      special_vocabulary: 'Vocabulaire spécial'
    },
    custom_vocabulary: {
      custom_vocabulary: 'Mon vocabulaire'
    },
    write: {
      subject: 'Sujet',
      message: 'Message',
      from: 'De',
      to: 'À',
      send: 'Envoyer'
    },
    course: {
      welcome: 'Bienvenue dans le cours. Commençons par quelques mots et phrases simples.',
      story: 'Histoire courte',
      vocabularies: 'Vocabulaire',
      flipcards: 'Révision avec cartes mémoire',
      exercises: 'Exercices de vocabulaire',
      sentences_only: 'Résumé des phrases',
      gap_text: 'Exercice à trous',
      flipcard_loosers: 'Révision des mots difficiles',
      exercises_loosers: 'Exercices pour mots difficiles',
      grammar: 'Leçon de grammaire',
      phrases: 'Phrases',
      phrases_repeat: 'Répétition des phrases',
      sentence_matcher: "Exercice d'appariement de phrases",
      def_matcher: "Exercice d'appariement de définitions",
      train_questions: "Questions d'entraînement"
    }
  },
  [Language.IT]: {
    general: {
      feeds: 'Notizie',
      videos: 'Video',
      kids: 'Bambini',
      wikipedia: 'Wikipedia',
      books: 'Libri',
      kids_lexicon: 'Enciclopedia per bambini',
      conversations: 'Chat',
      write: 'Scrivere',
      grammar: 'Grammatica',
      translate: 'Tradurre',
      vocabulary: 'Vocabolario',
      jokes: 'Barzellette',
      live_conversations: 'Parlare',
      transcription: 'Trascrizione',
      video_object_detection: 'Riconoscimento Oggetti'
    },
    feed_topics: {
      world: 'MONDO',
      business: 'AFFARI',
      technology: 'TECNOLOGIA',
      entertainment: 'INTRATTENIMENTO',
      science: 'SCIENZA',
      sports: 'SPORT',
      health: 'SALUTE',
      nation: 'NAZIONE'
    },
    chat: {
      chat: 'Chat',
      language_teacher: 'Insegnante di lingue'
    },
    category: {
      show_all_about: 'Mostra tutto su',
      [CategoryType.PHRASES]: 'Frasi',
      [CategoryType.SIMPLE_TEXTS]: 'Testi semplici',
      [CategoryType.SAYINGS]: 'Detto',
      [CategoryType.CONVERSATIONS]: 'Conversazioni',
      [CategoryType.WRITE]: 'Scrivere',
      course: 'Corso',
      categories: CATEGORIES_IT
    },
    custom: {
      own_text: 'Proprio testo'
    },
    special_vocabulary: {
      special_vocabulary: 'Vocabolario speciale'
    },
    custom_vocabulary: {
      custom_vocabulary: 'Mio vocabolario'
    },
    write: {
      subject: 'Soggetto',
      message: 'Messaggio',
      from: 'Da',
      to: 'A',
      send: 'Inviare'
    },
    course: {
      welcome: 'Benvenuto al corso. Iniziamo con alcune parole e frasi semplici.',
      story: 'Storia breve',
      vocabularies: 'Vocabolario',
      flipcards: 'Ripasso con flashcard',
      exercises: 'Esercizi di vocabolario',
      sentences_only: 'Riassunto delle frasi',
      gap_text: 'Esercizio a riempimento',
      flipcard_loosers: 'Ripasso parole difficili',
      exercises_loosers: 'Esercizi per parole difficili',
      grammar: 'Lezione di grammatica',
      phrases: 'Phrases',
      phrases_repeat: 'Ripetizione delle frasi',
      sentence_matcher: 'Esercizio di abbinamento delle frasi',
      def_matcher: 'Esercizio di abbinamento delle definizioni',
      train_questions: 'Domande di pratica'
    }
  },
  [Language.PT]: {
    general: {
      feeds: 'Notícias',
      videos: 'Vídeos',
      kids: 'Crianças',
      wikipedia: 'Wikipedia',
      books: 'Livros',
      kids_lexicon: 'Enciclopédia para crianças',
      conversations: 'Chat',
      write: 'Escrever',
      grammar: 'Gramática',
      translate: 'Traduzir',
      vocabulary: 'Vocabulário',
      jokes: 'Piadas',
      live_conversations: 'Falar',
      transcription: 'Transcrição',
      video_object_detection: 'Detecção de Objetos'
    },
    feed_topics: {
      world: 'MUNDO',
      business: 'NEGÓCIOS',
      technology: 'TECNOLOGIA',
      entertainment: 'ENTRETENIMENTO',
      science: 'CIÊNCIA',
      sports: 'ESPORTES',
      health: 'SAÚDE',
      nation: 'NAÇÃO'
    },
    chat: {
      chat: 'Chat',
      language_teacher: 'Professor de idiomas'
    },
    category: {
      show_all_about: 'Mostrar tudo sobre',
      [CategoryType.PHRASES]: 'Frases',
      [CategoryType.SIMPLE_TEXTS]: 'Textos simples',
      [CategoryType.SAYINGS]: 'Ditos',
      [CategoryType.CONVERSATIONS]: 'Conversas',
      [CategoryType.WRITE]: 'Escrever',
      course: 'Curso',
      categories: CATEGORIES_PT
    },
    custom: {
      own_text: 'Texto próprio'
    },
    special_vocabulary: {
      special_vocabulary: 'Vocabulário especial'
    },
    custom_vocabulary: {
      custom_vocabulary: 'Meu vocabulário'
    },
    write: {
      subject: 'Assunto',
      message: 'Mensagem',
      from: 'De',
      to: 'Para',
      send: 'Enviar'
    },
    course: {
      welcome: 'Bem-vindo ao curso. Vamos começar com algumas palavras e frases simples.',
      story: 'História curta',
      vocabularies: 'Vocabulário',
      flipcards: 'Revisão com cartões',
      exercises: 'Exercícios de vocabulário',
      sentences_only: 'Resumo das frases',
      gap_text: 'Exercício de preenchimento',
      flipcard_loosers: 'Revisão de palavras difíceis',
      exercises_loosers: 'Exercícios para palavras difíceis',
      grammar: 'Lição de gramática',
      phrases: 'Phrases',
      phrases_repeat: 'Repetição de frases',
      sentence_matcher: 'Exercício de correspondência de frases',
      def_matcher: 'Exercício de correspondência de definições',
      train_questions: 'Perguntas de prática'
    }
  },
  [Language.RU]: {
    general: {
      feeds: 'Новости',
      videos: 'Видео',
      kids: 'Дети',
      wikipedia: 'Wikipedia',
      books: 'Книги',
      kids_lexicon: 'Энциклопедия для детей',
      conversations: 'Чат',
      write: 'Писать',
      grammar: 'Грамматика',
      translate: 'Переводить',
      vocabulary: 'Словарь',
      jokes: 'Анекдоты',
      live_conversations: 'Разговор',
      transcription: 'Транскрипция',
      video_object_detection: 'Распознавание Объектов'
    },
    feed_topics: {
      world: 'МИР',
      business: 'БИЗНЕС',
      technology: 'ТЕХНОЛОГИИ',
      entertainment: 'РАЗВЛЕЧЕНИЯ',
      science: 'НАУКА',
      sports: 'СПОРТ',
      health: 'ЗДОРОВЬЕ',
      nation: 'НАЦИЯ'
    },
    chat: {
      chat: 'Чат',
      language_teacher: 'Учитель языка'
    },
    category: {
      show_all_about: 'Показать все о',
      [CategoryType.PHRASES]: 'Фразы',
      [CategoryType.SIMPLE_TEXTS]: 'Простые тексты',
      [CategoryType.SAYINGS]: 'Поговорки',
      [CategoryType.CONVERSATIONS]: 'Разговоры',
      [CategoryType.WRITE]: 'Писать',
      course: 'Курс',
      categories: CATEGORIES_RU
    },
    custom: {
      own_text: 'Собственный текст'
    },
    special_vocabulary: {
      special_vocabulary: 'Специальный словарь'
    },
    custom_vocabulary: {
      custom_vocabulary: 'Мой словарь'
    },
    write: {
      subject: 'Тема',
      message: 'Сообщение',
      from: 'От',
      to: 'Кому',
      send: 'Отправить'
    },
    course: {
      welcome: 'Добро пожаловать на курс. Давайте начнем с нескольких простых слов и предложений.',
      story: 'Короткая история',
      vocabularies: 'Простой словарь',
      flipcards: 'Повторение с карточками',
      exercises: 'Упражнения на словарный запас',
      sentences_only: 'Резюме предложений',
      gap_text: 'Упражнение с пропусками',
      flipcard_loosers: 'Повторение сложных слов',
      exercises_loosers: 'Упражнения для сложных слов',
      grammar: 'Урок грамматики',
      phrases: 'Phrases',
      phrases_repeat: 'Повторение фраз',
      sentence_matcher: 'Упражнение на сопоставление предложений',
      def_matcher: 'Упражнение на сопоставление определений',
      train_questions: 'Практика вопросов'
    }
  },
  [Language.ZH]: {
    general: {
      feeds: '新闻',
      videos: '视频',
      kids: '儿童',
      wikipedia: '维基百科',
      books: '书籍',
      kids_lexicon: '儿童百科',
      conversations: '聊天',
      write: '写作',
      grammar: '语法',
      translate: '翻译',
      vocabulary: '词汇',
      jokes: '笑话',
      live_conversations: '对话',
      transcription: '转录',
      video_object_detection: '物体识别'
    },
    feed_topics: {
      world: '世界',
      business: '商业',
      technology: '技术',
      entertainment: '娱乐',
      science: '科学',
      sports: '体育',
      health: '健康',
      nation: '国家'
    },
    chat: {
      chat: '聊天',
      language_teacher: '语言老师'
    },
    category: {
      show_all_about: '显示所有关于',
      [CategoryType.PHRASES]: '短语',
      [CategoryType.SIMPLE_TEXTS]: '简单文本',
      [CategoryType.SAYINGS]: '谚语',
      [CategoryType.CONVERSATIONS]: '对话',
      [CategoryType.WRITE]: '写作',
      course: '课程',
      categories: CATEGORIES_ZH
    },
    custom: {
      own_text: '自己的文本'
    },
    special_vocabulary: {
      special_vocabulary: '特殊词汇'
    },
    custom_vocabulary: {
      custom_vocabulary: '生词本'
    },
    write: {
      subject: '主题',
      message: '消息',
      from: '来自',
      to: '发送至',
      send: '发送'
    },
    course: {
      welcome: '欢迎来到课程。让我们从一些简单的单词和句子开始。',
      story: '短篇故事',
      vocabularies: '词汇',
      flipcards: '卡片复习',
      exercises: '词汇练习',
      sentences_only: '句子总结',
      gap_text: '填空练习',
      flipcard_loosers: '复习难词',
      exercises_loosers: '难词练习',
      grammar: '语法课',
      phrases: '短语',
      phrases_repeat: '短语复习',
      sentence_matcher: '句子匹配',
      def_matcher: '定义匹配',
      train_questions: '练习问题'
    }
  },
  [Language.PL]: {
    general: {
      feeds: 'Wiadomości',
      videos: 'Filmy',
      kids: 'Dzieci',
      wikipedia: 'Wikipedia',
      books: 'Książki',
      kids_lexicon: 'Encyklopedia dla dzieci',
      conversations: 'Czat',
      write: 'Pisać',
      grammar: 'Gramatyka',
      translate: 'Tłumaczyć',
      vocabulary: 'Słownictwo',
      jokes: 'Żarty',
      live_conversations: 'Rozmowa',
      transcription: 'Transkrypcja',
      video_object_detection: 'Rozpoznawanie Obiektów'
    },
    feed_topics: {
      world: 'ŚWIAT',
      business: 'BIZNES',
      technology: 'TECHNOLOGIA',
      entertainment: 'ROZRYWKA',
      science: 'NAUKA',
      sports: 'SPORT',
      health: 'ZDROWIE',
      nation: 'PAŃSTWO'
    },
    chat: {
      chat: 'Czat',
      language_teacher: 'Nauczyciel języka'
    },
    category: {
      show_all_about: 'Pokaż wszystko o',
      [CategoryType.PHRASES]: 'Zwroty',
      [CategoryType.SIMPLE_TEXTS]: 'Proste teksty',
      [CategoryType.SAYINGS]: 'Przysłowia',
      [CategoryType.CONVERSATIONS]: 'Rozmowy',
      [CategoryType.WRITE]: 'Pisać',
      course: 'Kurs',
      categories: CATEGORIES_PL
    },
    custom: {
      own_text: 'Własny tekst'
    },
    special_vocabulary: {
      special_vocabulary: 'Specjalne słownictwo'
    },
    custom_vocabulary: {
      custom_vocabulary: 'Mój słownik'
    },
    write: {
      subject: 'Temat',
      message: 'Wiadomość',
      from: 'Od',
      to: 'Do',
      send: 'Wyślij'
    },
    course: {
      welcome: 'Witamy na kursie. Zacznijmy od kilku prostych słów i zdań.',
      story: 'Krótka historia',
      vocabularies: 'Prosty słownik',
      flipcards: 'Powtórka z kartami',
      exercises: 'Ćwiczenia słownictwa',
      sentences_only: 'Podsumowanie zdań',
      gap_text: 'Ćwiczenie uzupełniania luk',
      flipcard_loosers: 'Powtórka trudnych słów',
      exercises_loosers: 'Ćwiczenia trudnych słów',
      grammar: 'Lekcja gramatyki',
      phrases: 'Phrases',
      phrases_repeat: 'Powtórka zwrotów',
      sentence_matcher: 'Ćwiczenie dopasowywania zdań',
      def_matcher: 'Ćwiczenie dopasowywania definicji',
      train_questions: 'Ćwiczenia pytań'
    }
  }
};

export default () => {
  const { langForeign } = language.state;
  const getLangLevelMenu = () => {
    if (!langForeign.value) return {};
    return {
      [LanguageLevel.A1_A2]: [
        TRANS[langForeign.value].category.phrases,
        TRANS[langForeign.value].category.simple_texts
      ],
      [LanguageLevel.B1_B2]: [],
      [LanguageLevel.C1_C2]: []
    };
  };
  return {
    consts: { TRANS },
    funcs: { getLangLevelMenu }
  };
};
